export const applyClassesForBreakpoint = (breakpoint: string, classes: string) => {
  const classesArray = classes.split(' ');

  return classesArray.map((className) => `${breakpoint}:${className}`).join(' ');
};
